import React, {Component} from 'react';

import {Table} from 'reactstrap';
import {toast} from 'react-toastify';
import ReactTooltip from 'react-tooltip';
// import ReactPlayer from 'react-player';

import ErrorMsg from "../common/ErrorMsg";
import LoadingModal from "../common/LoadingModal";
import {DESTINATION_INDEX} from "./constants";
import KPIPlanningSetting from "./SettingModal";


export default class Destinations extends Component {

    state = {
        isLoading: false,
        openSettingModal: false,
        selectedCategory: {}
    };

    componentDidMount = () => {
        if (this.props.agencyLocation) {
            this.getInitialState();
        }
    };

    getInitialState = async () => {
        if (this.props.permission.can_view) {
            if (this.props.kpiPlanning.categories.length === 0) {
                try {
                    await this.props.getKPIPlanningCategories();
                } catch (error) {
                    toast.error(<ErrorMsg errors={error} />)
                }
            }
            try {
                await this.props.getDestinations(this.props.agencyLocation);
            } catch (error) {
                toast.error(<ErrorMsg errors={error} />)
            }
        }
    };

    openSetting = (destination) => {
        this.setState((prevState) => ({
            selectedCategory: destination, 
            openSettingModal: !prevState.openSettingModal
        }));
    };

    toggleSettingModal = () => {
        this.setState({openSettingModal: false});
    }

    handleDestinationSelection = async (e, prevItem, optionList) => {
        try {
            let newValue = parseInt(e.target.value);
            let newItem = optionList.filter(item => item.id === newValue)[0];
            let newItemObj = newItem ? {...newItem, is_selected: true} : null;
            await this.deselectItem(prevItem);
            await this.selectItem(newItemObj);
            if(this.props.iw) {
                this.props.autocompleteModule();
            }
        } catch(error) {
            console.log(error);
        }
    }

    selectItem = async (itemObj) => {
        if (this.props.permission.can_add || this.props.permission.can_edit) {
            if (itemObj) {
                try {
                    await this.props.updatetable(
                        itemObj, this.props.kpiPlanning.destinationItems, DESTINATION_INDEX
                    );
                } catch(error) {
                    console.log(error);
                }
            }
        }
    }

    deselectItem = async (itemObj) => {
        if (itemObj) {
            try {
                let deselectedItem = {...itemObj, is_selected: false};
                await this.props.updatetable(
                    deselectedItem, this.props.kpiPlanning.destinationItems, DESTINATION_INDEX
                );
            } catch(error) {
                console.log(error);
            }
        }
    }

    render() {
        const {isLoading, openSettingModal, selectedCategory} = this.state;
        const {iw, kpiTab, edit} = this.props;
        let tableHeadings = [], optionsList = {}, optionItemList = {}, selectedItemsGroup = {};
        
        // create options list, selected items
        this.props.kpiPlanning.categories.map((category, index) => {
            tableHeadings.push(
                <th className="font-weight-bold text-center" key={index}>
                    {category.category}&nbsp;
                    <i className="fa fa-info-circle" data-tip data-for={`category-${index}`}></i>
                    <ReactTooltip className="react-tooltip-class" id={`category-${index}`}>
                        <span>{category.description}</span>
                    </ReactTooltip>
                    {edit &&
                        <a href="javascript:" className="float-right" 
                                onClick={() => this.openSetting(category)}
                        ><i className="fa fa-cog"></i></a>
                    }
                </th>
            );
            // options = option list for the columns
            // optionItems = object list of options for the columns
            let options = [], selectedItems = [], optionItems = [];
            this.props.kpiPlanning.destinationItems.filter((item, optInd) => {
                if (item.kpi_planning_category === category.id) {
                    if (!item.is_selected) {
                        optionItems.push(item);
                        options.push(
                            <option key={optInd} value={item.id}>{item.item}</option>
                        );
                    } else {
                        selectedItems.push(item);
                    }
                    return true;
                }
                return false;
            });
            optionItemList[category.id] = optionItems
            optionsList[category.id] = options;
            selectedItemsGroup[category.id] = selectedItems;
        });
        
        // Generate rows for destinations
        let rows = [];
        for (let row=0; row < 5; row++) {
            let tds = this.props.kpiPlanning.categories.map((col, index) => {

                let selectedItems = selectedItemsGroup[col.id];
                // looking for item selected for the row and col
                let curItem = selectedItems[row];

                return (<td key={index} className="kpi-planning-td">
                    {curItem ? curItem.item : <span>&nbsp;</span>}
                    {edit &&
                        <select name="kpi" className="kpi-planning-select" 
                                value={curItem ? curItem.id : 0 } 
                                onChange={(e) => this.handleDestinationSelection(
                                    e, curItem, optionItemList[col.id])}
                        >
                            {curItem ? 
                                <React.Fragment>
                                    <option value={0}>------Unselect Destination-----</option>
                                    <option value={curItem.id}>{curItem.item}</option>
                                </React.Fragment>
                                : <option value={0} disabled>-----Select Destination-----</option>
                            }
                            {optionsList[col.id]}
                        </select>
                    }
                </td>);
            });
            rows.push(<tr key={row}>{tds}</tr>);
        }       
    
        return (
            <div className="tab-pane" role="tabpanel">
                <div className="row">
                    <div className="col-12">
                        {/* {iw || kpiTab ? null : 
                            <div className="text-center mb-3">
                                <label className="mb-1">Why am I being asked to change?</label>
                                <div className="row">
                                    <div className="col-sm-3"></div>
                                    <div className="col-sm-6">
                                        <ReactPlayer 
                                            url={"https://www.youtube.com/watch?v=BMU06rYzRNE"} 
                                            controls width='100%' height='100%'
                                        />
                                    </div>
                                </div>
                            </div>
                        } */}
                        <Table striped bordered size="sm" className="mb-0">
                            <thead className="bg-f5">
                                {kpiTab && 
                                    <tr>
                                        <th colSpan="5" className="text-center border-left-0
                                         border-right-0 font-weight-bold"
                                        >
                                            Destinations
                                        </th>
                                    </tr>
                                }
                                <tr>
                                    {tableHeadings}
                                </tr>
                            </thead>
                            <tbody>
                                <tr></tr>
                                {rows}
                            </tbody>
                        </Table>
                    </div>
                </div>
                {isLoading ? <LoadingModal modal={isLoading} /> : null}
                {openSettingModal ? 
                    <KPIPlanningSetting {...this.props} modal={openSettingModal}
                        type={DESTINATION_INDEX} 
                        toggle={this.toggleSettingModal}
                        selectedCategory={selectedCategory}
                        jobTitle={0}
                    /> 
                    : null
                }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/kpiPlanning/Destinations.js